import { getCssVariables } from "@config/theme/css-variables";
import type { ThemeMode } from "@config/theme/tokens";
import { DOM_ATTRIBUTES } from "@constants/dom";

export function applyThemeCssVariables(mode: ThemeMode = "light"): void {
	const root = document.documentElement;
	const variables = getCssVariables(mode);

	root.setAttribute(DOM_ATTRIBUTES.themeMode, mode);
	root.style.colorScheme = "light";

	for (const [name, value] of Object.entries(variables)) {
		root.style.setProperty(name, value);
	}
}

export function bootstrapTheme(): ThemeMode {
	const mode: ThemeMode = "light";
	applyThemeCssVariables(mode);
	return mode;
}
